module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House54.88d72315.jpg";